import Image from "next/image";

import type { ResponsiveImageUrls } from "./types";

interface NextImageVariantProps {
  imageData: ResponsiveImageUrls;
  fill?: boolean;
  width?: number;
  height?: number;
  priority?: boolean;
  quality?: number;
  sizes?: string;
  className?: string;
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
  objectPosition?: string;
  [key: string]: any;
}

export function NextImageVariant({
  imageData,
  fill,
  width,
  height,
  priority = false,
  quality,
  sizes,
  className,
  objectFit: _objectFit, // Not used - handled by className Tailwind classes
  objectPosition,
  ...props
}: NextImageVariantProps) {
  // For Next.js Image, we use the fallback URL as the src
  // The picture element handles responsive selection before this component
  const src = imageData.fallback || imageData.desktop || imageData.tablet || imageData.mobile;

  if (!src) return null;

  const imageProps: any = {
    src,
    alt: imageData.alt,
    priority,
    className,
    // Don't set objectFit/objectPosition in inline styles - let className handle it
    // Next.js Image and Tailwind classes handle object-fit/object-position
    style: objectPosition
      ? {
          objectPosition,
        }
      : undefined,
    ...props,
  };

  if (fill) {
    // For fill mode, only pass sizes if explicitly provided
    // Next.js Image defaults to "100vw" automatically
    return <Image {...imageProps} fill {...(sizes && { sizes })} />;
  }

  if (width && height) {
    return <Image {...imageProps} width={width} height={height} quality={quality} />;
  }

  // If no dimensions specified, use a default size
  return <Image {...imageProps} width={1200} height={600} quality={quality} />;
}
